import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute, Router} from '@angular/router';
import {MasterDataService} from '../../../../../views/oes/services/master-data.service';
import {ToastrService} from 'ngx-toastr';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-m-master-data-view',
    templateUrl: './m-master-data-view.component.html',
    styleUrls: ['./m-master-data-view.component.scss'],
    providers: [
        MasterDataService
    ]
})
export class MMasterDataViewComponent implements OnInit, OnDestroy {

    public loading: boolean;
    public record: any;
    public allowInventoryManagement: boolean;

    private MD1_ID: number;
    private subscription: Subscription;

    constructor(
        private route: ActivatedRoute,
        private masterDataService: MasterDataService,
        private router: Router,
        private toast: ToastrService,
        private title: Title
    ) {
        this.title.setTitle('OES - Master Data View');
    }

    ngOnInit() {
        this.loading = false;
        this.record = this.masterDataService.initialize();
        this.MD1_ID = (this.route.snapshot.params.id !== undefined && this.route.snapshot.params.id !== null)
            ? this.route.snapshot.params.id : 0;
        window.scroll(0, 0);
        this.getData();
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    onCancel() {
        this.loading = false;
        window.history.back();
    }

    private getData() {
        if (this.MD1_ID > 0) {
            this.loading = true;
            this.subscription = this.masterDataService.getById(this.MD1_ID).subscribe(masterDataResult => {
                if (masterDataResult.success) {
                    this.record = masterDataResult.data;
                    this.record.CO1_ID = Number(masterDataResult.data.CO1_ID);
                    this.record.CU1_ID = Number(masterDataResult.data.CU1_ID);
                    this.record.RA1_ID = Number(masterDataResult.data.RA1_ID);
                    this.allowInventoryManagement = Number(masterDataResult.masterCustomer.CU0_ALLOW_INVENTORY_MANAGEMENT) === 1;
                    this.loading = false;
                } else {
                    this.toast.error('Unable to load data. Please try later!', 'Error');
                    setTimeout(() => {
                        this.onCancel();
                    }, 1000);
                }
            }, () => {
                this.onCancel();
                this.toast.error('Request timed out', 'Service Error');
            });
        } else {
            this.toast.error('Unable to fetch data.', 'Error');
            setTimeout(() => {
                this.onCancel();
            }, 1000);
        }
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/modules/mobile/views/master-data/master-data-view/m-master-data-view.component.ts